// @flow
import urlUtil from 'app/common/lib/urlUtil';
import { GuidePageUsernameSlugToLocale } from 'app/common/react/components/growth/unauth/UnauthGuidePage/constants';
import { type UnauthSeoExperiments } from 'app/common/lib/react/withUnauthSeoExperiments';

export const inGuidePageExperience = (
  username: string,
  slug: string,
  locale: ?string,
  seoUnauthExperiments: UnauthSeoExperiments,
) => {
  const applicableLocale = GuidePageUsernameSlugToLocale[username + '/' + slug];
  return (
    applicableLocale &&
    locale &&
    locale.includes(applicableLocale) &&
    (seoUnauthExperiments.v2ActivateExperiment('holiday_guide_page') || '').startsWith('enabled')
  );
};

export const isUrlInGuidePageExperience = (
  pageType: string,
  currentUrl: string,
  locale: ?string,
  seoUnauthExperiments: UnauthSeoExperiments,
) => {
  if (pageType === 'board') {
    const relativeUrl = urlUtil.getUnauthPageId(pageType, currentUrl);
    const urlParts = relativeUrl.split('/');
    if (urlParts.length === 2) {
      const [username, encodedSlug] = urlParts;
      const decodedSlug = decodeURIComponent(encodedSlug);
      return inGuidePageExperience(username, decodedSlug, locale, seoUnauthExperiments);
    }
  }
  return false;
};

export default {
  isUrlInGuidePageExperience,
  inGuidePageExperience,
};
